export type RollbackStackingConfig = 'ALL' | 'OFF' | 'PER_OFFER';

export const allRollbackStackingConfigOptions: RollbackStackingConfig[] = [
  'ALL',
  'OFF',
  'PER_OFFER',
];

export type OfferReturnStrategy = 'ON' | 'OFF' | 'PER_OFFER';
